export function Spinner({ label = 'Loading' }: { label?: string }) {
  return (
    <p className="muted" role="status" style={{ padding: '2rem 0', textAlign: 'center' }}>
      {label}
    </p>
  );
}
